import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { PaginatedResult } from 'src/app/util';
import { FollowedList } from 'src/app/models/user-item-list';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { FollowedAuthor } from 'src/app/models/followed-author';
import { UserListFacade } from '../../../state/user-list/user-list.facade';
import { Router } from '@angular/router';
import { FavoritesFacade } from 'src/app/state/user/favorites/favorites.facade';
import { EditListFacade } from '../../../edit-list/state/edit-list.facade';

@Component({
  selector: 'app-user-lists',
  templateUrl: './user-lists.component.html',
  styleUrls: ['./user-lists.component.scss'],
})
export class UserListsComponent implements OnInit {
  private readonly INITIAL_PAGE_SIZE = 10;
  private readonly editListFacade = inject(EditListFacade);

  readonly favoritesFacade = inject(FavoritesFacade);
  readonly paginatedFavorites$ = this.favoritesFacade.paginatedFavorites$;
  readonly isLoading$ = this.favoritesFacade.isLoading$;

  section = 'lists';
  loadingFollowings = true;
  loadingUserData: boolean;
  listFollowings: PaginatedResult<FollowedList>;
  followedAuthors: FollowedAuthor[] = [];

  pageSizeOptions: number[];
  selectedPageSize: number = this.INITIAL_PAGE_SIZE;
  selectedPage = 0;
  selectedTabIndex = 0;

  constructor(
    public userService: UserService,
    private broadcastService: BroadcastService,
    private userListFacade: UserListFacade,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadingUserData = this.userService.isLoadingLists;
    if (this.loadingUserData) {
      this.broadcastService.userData$.subscribe((response) => (this.loadingUserData = response));
    }
    this.favoritesFacade.getPaginatedFavorites();
    this.userService.getUserLists();
    this.userService.loadFollowedAuthors().subscribe((result) => (this.followedAuthors = result));
    this.broadcastService.listUnfollowed$.subscribe(() =>
      this.loadListFollowings(this.selectedPageSize, this.selectedPage)
    );

    this.selectedTabIndex = this.userListFacade.activeTab;

    if (this.selectedTabIndex === 1) {
      this.loadListFollowings(this.INITIAL_PAGE_SIZE, 0);
    }
  }

  private loadListFollowings(pageSize: number, page: number) {
    const limit = pageSize;
    const offset = page * pageSize;
    this.loadingFollowings = true;
    this.userService.getUserListSubscriptions(limit, offset).subscribe((result) => {
      this.listFollowings = result;
      this.loadingFollowings = false;
      this.pageSizeOptions = [this.listFollowings.itemsPerPage, 24, 48];
    });
  }

  addAuthors() {
    this.router.navigate(['/search', 'authors']);
  }

  exploreLists() {
    const params = {
      limit: 24,
      offset: 0,
      facets: 'format_facet_ss:"LIST"',
      order: 'fechaModifica_dt:desc',
    };

    this.router.navigate(['/results'], { queryParams: params });
  }

  pageChangeHandler(event: PageEvent) {
    this.selectedPage = event.pageIndex;
    this.selectedPageSize = event.pageSize;
    this.loadListFollowings(event.pageSize, event.pageIndex);
  }

  tabChanged(event: number) {
    this.userListFacade.setActiveTab(event);

    if (event === 1) {
      this.loadListFollowings(this.INITIAL_PAGE_SIZE, 0);
    }
  }

  openCreateListModal() {
    this.editListFacade.openDialog();
  }
}
